import { MUTUAL_FUND_DETAIL_IMAGE_URL } from '../../constants'
import RenderHTML from './RenderHTML'

type TextBubblePropTypes = {
  text: string
  onLearnMore?: () => void
  learnMoreText?: string
}

export default function TextBubble({ text, onLearnMore, learnMoreText = 'Learn more' }: TextBubblePropTypes) {
  return (
    <div className='flex gap-[4px] font-[400] text-13 text-[#6A6E6E] leading-[18px]'>
      <div aria-hidden='true'>
        <img src={`${MUTUAL_FUND_DETAIL_IMAGE_URL}/normal-expression.svg`} alt='' className='w-10 h-10 mt-1' />
      </div>
      <div className='relative flex-1'>
        <div aria-hidden='true' className='absolute left-[-7px] top-[6px]'>
          <RenderHTML
            innerHTMLText='<svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 2.5C10 2.5 7.45367 0.216265 2.00014 1.2039C3.08465 1.66685 7.15493 4.44457 7 10" stroke="#EBF2F2"/>
<path d="M3.5 1.5C8.5 1 11.5 4 12.5 4.5C10.5 4.5 8 8 7.5 9.5C7 6 6.5 4 3.5 1.5Z" fill="white"/>
</svg>

'
          />
        </div>
        <div className='rounded-[12px] p-3 border border-[#EAF5FF]'>
          <span>{text} </span>
          {onLearnMore && (
            <button
              type='button'
              aria-label={learnMoreText}
              onClick={onLearnMore}
              className='underline text-[#232323] bg-transparent border-none p-0 m-0 cursor-pointer font-inherit text-inherit min-h-[24px]'
            >
              {learnMoreText}
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
